var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClauseManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40707 13.8461H10.5929L10.7948 12.7084C11.0363 12.639 11.2446 12.5567 11.4198 12.4615C11.5951 12.3665 11.7671 12.2394 11.9358 12.0801L13.0321 12.4551L13.6329 11.4392L12.7627 10.702C12.8226 10.4542 12.8525 10.2202 12.8525 10.0001C12.8525 9.77994 12.8226 9.54598 12.7627 9.29821L13.6329 8.56091L13.0321 7.54508L11.9358 7.92008C11.7671 7.76078 11.5951 7.63362 11.4198 7.53862C11.2446 7.44348 11.0363 7.36119 10.7948 7.29175L10.5929 6.15404H9.40707L9.2052 7.29175C8.96367 7.36119 8.75534 7.44348 8.5802 7.53862C8.40492 7.63362 8.23291 7.76078 8.06416 7.92008L6.96791 7.54508L6.36707 8.56091L7.23728 9.29821C7.17742 9.54598 7.14749 9.77994 7.14749 10.0001C7.14749 10.2202 7.17742 10.4542 7.23728 10.702L6.36707 11.4392L6.96791 12.4551L8.06416 12.0801C8.23291 12.2394 8.40492 12.3665 8.5802 12.4615C8.75534 12.5567 8.96367 12.639 9.2052 12.7084L9.40707 13.8461ZM9.99999 11.6667C9.54166 11.6667 9.1493 11.5036 8.82291 11.1772C8.49652 10.8508 8.33332 10.4584 8.33332 10.0001C8.33332 9.54175 8.49652 9.14939 8.82291 8.823C9.1493 8.49661 9.54166 8.33342 9.99999 8.33342C10.4583 8.33342 10.8507 8.49661 11.1771 8.823C11.5035 9.14939 11.6667 9.54175 11.6667 10.0001C11.6667 10.4584 11.5035 10.8508 11.1771 11.1772C10.8507 11.5036 10.4583 11.6667 9.99999 11.6667ZM4.42311 17.0834C4.00214 17.0834 3.64582 16.9376 3.35416 16.6459C3.06249 16.3542 2.91666 15.9979 2.91666 15.577V4.42321C2.91666 4.00223 3.06249 3.64591 3.35416 3.35425C3.64582 3.06258 4.00214 2.91675 4.42311 2.91675H15.5769C15.9978 2.91675 16.3542 3.06258 16.6458 3.35425C16.9375 3.64591 17.0833 4.00223 17.0833 4.42321V15.577C17.0833 15.9979 16.9375 16.3542 16.6458 16.6459C16.3542 16.9376 15.9978 17.0834 15.5769 17.0834H4.42311ZM4.42311 15.8334H15.5769C15.641 15.8334 15.6998 15.8067 15.7531 15.7532C15.8066 15.6999 15.8333 15.6411 15.8333 15.577V4.42321C15.8333 4.35904 15.8066 4.30029 15.7531 4.24696C15.6998 4.19348 15.641 4.16675 15.5769 4.16675H4.42311C4.35895 4.16675 4.3002 4.19348 4.24687 4.24696C4.19339 4.30029 4.16666 4.35904 4.16666 4.42321V15.577C4.16666 15.6411 4.19339 15.6999 4.24687 15.7532C4.3002 15.8067 4.35895 15.8334 4.42311 15.8334Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClauseManagement);
export default __webpack_public_path__ + "static/media/clauseManagement.fcb70ad06a69dd399a4db7a03e30d825.svg";
export { ForwardRef as ReactComponent };